<template>
  <v-snackbar
    :value="isOpen"
    :timeout="timeout"
    auto-height
    bottom>
    {{ text }}
    <v-btn
      v-if="action"
      color="primary"
      flat
      @click.stop.prevent="onSnackbarActionClick">
      {{ action }}
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Snackbar',

  props: {
    isOpen: Boolean,
    text: String,
    link: String,
    action: String,
    timeout: {
      type: Number,
      default: 4000,
    },
  },

  methods: {
    ...mapMutations({
      closeSnackbar: 'ui/closeSnackbar',
    }),

    onSnackbarActionClick() {
      if (this.link) {
        this.$router.push(this.link);
      }
      this.closeSnackbar();
    },
  },
};
</script>
